import { render, staticRenderFns } from "./online-social-awareness.vue?vue&type=template&id=4dd5a80b&scoped=true"
import script from "./online-social-awareness.vue?vue&type=script&lang=js"
export * from "./online-social-awareness.vue?vue&type=script&lang=js"
import style0 from "./online-social-awareness.vue?vue&type=style&index=0&id=4dd5a80b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd5a80b",
  null
  
)

export default component.exports